"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nextIndex = nextIndex;
exports.prevIndex = prevIndex;
exports.swapInPlace = swapInPlace;
exports.jumpInPlace = jumpInPlace;

require("core-js/modules/es.array.splice.js");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Return the next index in an array if it exists,
 * otherwise return 0. Commonly used in carousels.
 * @param {[]} arr input array
 * @param {number} index starting index
 */
function nextIndex(arr, index) {
  if (index + 1 >= arr.length) return 0;
  return index + 1;
}

;
/**
 * Return the previous index in an array if it exists,
 * otherwise return the last index. Commonly used in carousels.
 * @param {[]} arr input array
 * @param {number} index starting index
 */

function prevIndex(arr, index) {
  if (!arr[index] || index < 1) return arr.length - 1;
  return index - 1;
}

;
/**
 * Swap 2 elements in an array
 * @template T
 * @param {T[]} arr input array
 * @param {number} a index of first element to swap
 * @param {number} b index of second element to swap
 */

function swapInPlace(arr, a, b) {
  if (arr[a] && arr[b]) {
    // eslint-disable-next-line no-param-reassign
    var _arr$splice = arr.splice(b, 1, arr[a]);

    var _arr$splice2 = _slicedToArray(_arr$splice, 1);

    arr[a] = _arr$splice2[0];
  }
}
/**
 * Jump an element to another spot in an array
 * @template T
 * @param {T[]} arr input array
 * @param {number} from index of second element to swap
 * @param {number} to index of first element to swap
 */


function jumpInPlace(arr, from, to) {
  if (arr[from] && arr[to]) {
    arr.splice(to, 0, arr.splice(from, 1)[0]);
  }
}